import { ReactNode } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { Spacer } from '@/components/elements/Spacer'

export type MapCardProps = {
  cpName: string
  cpSubName?: string
  cpAddress: string
  addressUrl: string
  children: ReactNode
}

export const MapCard = ({
  cpName,
  cpSubName,
  cpAddress,
  addressUrl,
  children,
}: MapCardProps) => {
  return (
    <>
      <AccessBody>
        <AccessText>
          <AccessCP>
            <h3>{cpName}</h3>
            {cpSubName && (
              <>
                <Spacer h={{ sp: 10, pc: 10 }} />
                <h4>{cpSubName}</h4>
              </>
            )}
            <Spacer h={{ sp: 20, pc: 26 }} />
            <p>{cpAddress}</p>
          </AccessCP>
          <StyleIframe src={addressUrl} allowFullScreen loading="lazy" />
          <MapTextDiv>{children}</MapTextDiv>
        </AccessText>
      </AccessBody>
    </>
  )
}

const AccessBody = styled.div`
  width: 1040px;
  border-radius: 8px;
  background-color: ${theme.colors.backgroundGrey};

  @media screen and (max-width: 1047px) {
    width: 100%;
  }
`
const AccessText = styled.div`
  width: 100%;
  padding: 40px 90px 0px;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  color: ${theme.colors.textTitle};

  @media screen and (max-width: 1047px) {
    padding: 30px 22px 0px;
    font-size: 15px;
  }
`

const AccessCP = styled.div`
  h3 {
    font-size: 30px;
    color: ${theme.colors.trialBlue};
    font-weight: bold;
    line-height: 1.2;
  }

  h4 {
    font-size: 18px;
    color: ${theme.colors.trialBlue};
    font-weight: bold;
    line-height: 1.2;
  }

  p {
    font-weight: 500;
    line-height: 1.6;
  }

  @media screen and (max-width: 1047px) {
    h3 {
      font-size: 20px;
      letter-spacing: 2px;
    }

    h4 {
      font-size: 13px;
    }
  }
`

const StyleIframe = styled.iframe`
  width: 100%;
  height: 500px;
  margin-top: 42px;

  @media screen and (max-width: 1047px) {
    height: 285px;
    margin-top: 32px;
  }
`

const MapTextDiv = styled.div`
  width: 100%;
  font-size: 16px;
  font-weight: bold;

  h4 {
    font-size: 18px;
    letter-spacing: 1.8px;
  }

  h5 {
    letter-spacing: 0.96px;
  }

  p {
    font-weight: normal;
    letter-spacing: 0.64px;
    line-height: 29px;
  }

  @media screen and (max-width: 1047px) {
    font-size: 15px;

    p {
      font-weight: 400;
      letter-spacing: 0.6px;
      line-height: 25px;
    }
  }
`

export const ZenkakuSpace = styled.span<{ space?: string }>`
  padding-left: ${({ space }) => (space === undefined ? '1em' : `${space}em`)};
`
